import { K365SetupGuidesAccessState } from '@layout/k365-setup-guides-access/store/states/k365-setup-guides-access.state';

export const k365SetupGuidesAccessState = [K365SetupGuidesAccessState];
